
class BankMappingKeyCell extends UITableViewCell
{
    private typeComboBox: MUIComboBox = null;
    private keyTextField: MUITextField = null;

    awakeFromHTML() {
        this.typeComboBox = MUIOutlet(this, "type-cb", "MUIComboBox");
        this.typeComboBox.setOnChangeAction(this, function(cb: MUIComboBox, value: string) {                        
            this._item.sourceKey = value;
        });

        this.keyTextField = MUIOutlet(this, "key-tf", "MUITextField");
        this.keyTextField.setOnChangeText(this, function(tf: MUITextField, value: string) {
            this._item.targetKey = value;
        });

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    private _item: IntegratorMappingKey = null;
    set item(item: IntegratorMappingKey) {
        this._item = item;

        this.typeComboBox.removeAllItems();
        
         this.typeComboBox.addItem(MIOLocalizeString("DATE", "DATE"), "DATE");
         this.typeComboBox.addItem(MIOLocalizeString("TIME", "TIME"), "TIME");
         this.typeComboBox.addItem(MIOLocalizeString("DUE DATE", "DUE DATE"), "DUE DATE");
         this.typeComboBox.addItem(MIOLocalizeString("CONCEPT", "CONCEPT"), "CONCEPT");
         this.typeComboBox.addItem(MIOLocalizeString("AMOUNT", "AMOUNT"), "AMOUNT");
         this.typeComboBox.addItem(MIOLocalizeString("BALANCE", "BALANCE"), "BALANCE");
         this.typeComboBox.addItem(MIOLocalizeString("TYPE", "TYPE"), "TYPE");
         this.typeComboBox.addItem(MIOLocalizeString("TYPE DESCRIPTION", "TYPE DESCRIPTION"), "TYPE DESCRIPTION");
         this.typeComboBox.addItem(MIOLocalizeString("DOCUMENT NUMBER", "DOCUMENT NUMBER"), "DOCUMENT NUMBER");
         this.typeComboBox.addItem(MIOLocalizeString("REFERENCE ID", "REFERENCE ID"), "REFERENCE ID");
         this.typeComboBox.addItem(MIOLocalizeString("REFERENCE 1", "REFERENCE 1"), "REFERENCE 1");
         this.typeComboBox.addItem(MIOLocalizeString("REFERENCE 2", "REFERENCE 2"), "REFERENCE 2");
         this.typeComboBox.addItem(MIOLocalizeString("EXCHANGE CURRENCY", "EXCHANGE CURRENCY"), "EXCHANGE CURRENCY");
         this.typeComboBox.addItem(MIOLocalizeString("EXCHANGE AMOUNT", "EXCHANGE AMOUNT"), "EXCHANGE AMOUNT");
         this.typeComboBox.addItem(MIOLocalizeString("EXCHANGE RATE", "EXCHANGE RATE"), "EXCHANGE RATE");
         this.typeComboBox.addItem(MIOLocalizeString("FEE", "FEE"), "FEE");
         this.typeComboBox.addItem(MIOLocalizeString("BENEFICIARY NAME", "BENEFICIARY NAME"), "BENEFICIARY NAME");
         this.typeComboBox.addItem(MIOLocalizeString("BENEFICIARY ACCOUNT NUMBER", "BENEFICIARY ACCOUNT NUMBER"), "BENEFICIARY ACCOUNT NUMBER");
         this.typeComboBox.addItem(MIOLocalizeString("BENEFICIARY IBAN", "BENEFICIARY IBAN"), "BENEFICIARY IBAN");
         this.typeComboBox.addItem(MIOLocalizeString("EXTRA", "EXTRA"), "EXTRA");


        if (item.sourceKey) {
            this.typeComboBox.selectItem(item.sourceKey);
        }

        this.keyTextField.text = item.targetKey;        
    }
}
